import React, { Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  ItemsList,
  SubtotalBlock,
  TotalBlock,
} from 'components/Forms/CheckoutForm/ReviewItems';
import { changeItemQuantity, removeItem } from 'containers/Cart/actions';
import { selectCartSummary } from '../selectors';

const CartInfo = ({
  cart,
  page,
  handlePlaceOrder,
  loading,
  summary,
  isCheckout,
  ...props
}) => {
  const handleRemove = (itemId) => {
    props.removeItem({ cartId: cart.id, itemId });
  };

  const handleQuantityChange = (item, quantity) => {
    props.changeItemQuantity({ cartId: cart.id, item, quantity });
  };

  return (
    <Fragment>
      <ItemsList
        items={cart.items}
        onQuantityChange={handleQuantityChange}
        handleRemove={handleRemove}
        isCheckout={isCheckout}
      />
      <SubtotalBlock summary={summary} />
      <TotalBlock
        page={page}
        handlePlaceOrder={handlePlaceOrder}
        loading={loading}
        summary={summary}
        {...props}
      />
    </Fragment>
  );
};

CartInfo.propTypes = {
  cart: PropTypes.object, // TODO add isRequired
  changeItemQuantity: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  page: PropTypes.oneOf(['cart', 'checkout']),
  handlePlaceOrder: PropTypes.func,
  loading: PropTypes.bool,
  summary: PropTypes.object,
  isCheckout: PropTypes.bool,
};

CartInfo.defaultProps = {
  page: 'checkout',
  isCheckout: false,
};

const mapStateToProps = createStructuredSelector({
  summary: selectCartSummary(),
});

const mapDispatchToProps = {
  changeItemQuantity,
  removeItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartInfo);
